export default {
    kh: 'Khmer',
    en: 'English',
    lao:"Lao",
    thai:"Thai"
};
